<div class="header">
  <div class="header__title text_size-m text_truncate">
    {{ 'components.internalMessenger.labels.info' | translate }}
  </div>
  <button
    tuiIconButton
    type="button"
    class="header__close-button"
    appearance="icon"
    size="s"
    (click)="onClickCloseButton()"
  >
    <app-icon src="x"></app-icon>
  </button>
</div>
